import { useMutation } from '@tanstack/react-query';

import { receivingApi } from 'api/receiving';
import { ApiError } from 'shared/errors/ApiError';

/**
 * Receives a BAMS purchase order map group (grocery or packaging).
 *
 * @param {Omit<
 *   import('@tanstack/react-query').UseMutationOptions<
 *     Object,
 *     ApiError,
 *     { poType: string, groupId: number, payload: Object }
 *   >,
 *   'mutationFn'
 * >} [mutationOptions={}]
 * @returns {import('@tanstack/react-query').UseMutationResult<
 *   Object,
 *   ApiError,
 *   { poType: string, groupId: number, payload: Object }
 * >}
 */
export function useReceivePurchaseOrderMapGroupMutation(mutationOptions = {}) {
    return useMutation({
        mutationFn: async ({ groupId, payload, poType }) => {
            const response =
                poType === 'PACKAGING'
                    ? await receivingApi.receivePackagingPurchaseOrderMapGroup(groupId, payload)
                    : await receivingApi.receivePurchaseOrderMapGroup(groupId, payload);

            if (!response?.status) {
                throw new ApiError(
                    response?.msg ?? 'Failed to receive purchase order map group',
                    response?.statusCode,
                    response?.data,
                );
            }

            return response.data;
        },
        ...mutationOptions,
    });
}
